/* @flow */
/* global Buffer */

export default Buffer;
